<template>
	<vxe-modal v-model="showDrawer"  width="80%" height="800px"    remember :esc-closable="false"
			:destroy-on-close="true" :title="theRow.monitorName">
		<div class="actDiv">
			<label style="font-size: 0.8rem;margin-left: 0.625rem;">日期：</label>
			<a-range-picker  style="font-size: 0.6875rem;width: 15rem;" v-model="theDateList"
							format="YYYY-MM-DD" @change="onDateChange" size="small">
			</a-range-picker>
			<a-select style="width:5.5rem;  font-size: 0.6875rem;margin-left: 0.625rem;" v-model="theType"  >
				<a-select-option v-for="item in typeList" :key="item.index" :value="item.index">
					{{item.name}}
				</a-select-option>
			</a-select>
			<a-button size="small"   icon="search" @click="doQuery()" style="margin: 0 0.5rem;" :loading="loading">查询</a-button>
			<a-button size="small" :disabled="dataList.length == 0" style="margin-left: 0.625rem" icon="download" @click="downloadImage()"> 导出图片 </a-button>
		</div>
		<div id="lineBarChart"></div>
	</vxe-modal>
</template>

<script>
		import * as echarts from 'echarts';
	export default {
		data(){
			return {
				loading:false,
				showDrawer:false,
				theRow:{},
				dateStart:null,
				dateEnd:null,
				theDateList:[],
				dataList:[],
				theType:null,
				lineBarChart:null,
				typeList:[
					{
						name:'同比',
						index:1,
					},
					{
						name:'环比',
						index:2,
					},
					{
						name:'自定义',
						index:3,
					}
				],
			}
		},
		methods: {
			downloadImage(){
				const charts = document.getElementById("lineBarChart").getElementsByTagName('canvas');
				const element = document.createElement("a");
				element.download =theRow.monitorName +".png"
				element.href = charts[0].toDataURL("image/png")
				document.body.appendChild(element)
				element.click();
				element.remove();
			},
			onDateChange(date, dateString) {
				this.dateStart=dateString[0];
				this.dateEnd=dateString[1];
			},
			showView(row,beginDate,endDate,type) {
				this.theRow = row;
				this.showDrawer = true;
				this.theType = this.Config.deepClone(type);
				this.dateStart = this.Config.deepClone(beginDate);
				this.dateEnd = this.Config.deepClone(endDate);
				this.theDateList = [this.dateStart,this.dateEnd];
				this.doQuery();
			},
			doQuery(){
				this.loading = true;
				let param = {
					meterId:this.theRow.meterId,
					type:this.theType,
					beginDate:this.dateStart,
					endDate:this.dateEnd,
				}
				let url = this.Api.getLastUrl(this.Api.METER_MONITOR_YOY_STATIS_CHART_URL);
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.loading = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.dataList = result;
						this.initCharts();
						this.drawCharts();
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.loading = false;
					console.log(error);
				});
			},
			drawCharts(){
				var xData = [];
				var thisFlowData = [];
				var lastFlowData = [];
				var ratioData = [];
				for(var i = 0;i<this.dataList.length;i++){
					let item = this.dataList[i];
					var temp = item.thisActionTime+" "+item.lastActionTime;
					xData.push(temp);
					thisFlowData.push(item.thisFlow);
					lastFlowData.push(item.lastFlow);
					ratioData.push(item.ratioAbs);
				}
				var theFlowName = "";
				switch (this.theType){
					case 1:
						theFlowName = "同比"
						break;
					case 2:
						theFlowName = "环比"
						break;
					default:
						break;
				}
				var option = {
					title:{
						text:'抄收数据曲线('+this.theRow.monitorName+')',
						left:'center'
					},
					grid:{
						bottom:135
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'cross',
							crossStyle: {
								color: '#999'
							}
						},
						formatter:(params)=>{
							let theItem = this.dataList[params[0].dataIndex];
							let arrow = null;
							if(theItem.ratio<0){
								arrow = "↓";
							}else if(theItem.ratio>0){
								arrow = "↑";
							}else{
								arrow = "";
							}
							let str = "";
							str+="本期："+theItem.thisActionTime+"</br>";
							str+=theFlowName+"："+theItem.lastActionTime+"</br>";
							str+=params[0].marker+params[0].seriesName+"："+arrow+params[0].value+"%</br>";
							str+=params[1].marker+params[1].seriesName+"："+params[1].value+"立方米</br>";
							str+=params[2].marker+params[2].seriesName+"："+params[2].value+"立方米</br>";
							return str;
						},
					},
					legend: {
						data: ['波动','本期流量', theFlowName+'流量'],
						x:'center', 
						y:'bottom',
					},
					xAxis:[
						{
							type:'category',
							data:xData,
							axisLabel: {
								interval: 0,
								rotate: 45,
							},
						}
					],
					yAxis:[
						{
							type: 'value',
							name: '流量',
							interval:50,
							axisLabel: {
								formatter: '{value} 立方米'
							},
							min:0,
						},
						{
							type: 'value',
							name: '波动幅度',
							interval:20,
							min: 0,
						},
					],
					series:[
						{
							name: '波动',
							type: 'line',
							yAxisIndex: 1,
							data: ratioData,
						},
						{
							name: '本期流量',
							type: 'bar',
							data: thisFlowData,
							label: {
								show: true,
								position: 'top'
							},
							itemStyle:{
								color:"#5C7BD9"
							}
						},
						{
							name: theFlowName+'流量',
							type: 'bar',
							data: lastFlowData,
							label: {
								show: true,
								position: 'top'
							},
							itemStyle:{
								color:"#91CC75"
							}
						},
					]
				};
				this.lineBarChart.setOption(option);
			},
			initCharts(){
				let a = window.document.getElementById("lineBarChart");
				this.lineBarChart = echarts.init(a);
			},
		},
	}
</script>

<style>
	#lineBarChart{
		width: 100%;
		height: 680px;
	}
</style>
